import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import collapseIcon from '@ingka/ssr-icon/paths/chevron-double-up';
import expandIcon from '@ingka/ssr-icon/paths/chevron-double-down';
import { useExpanded } from '../../state/expanded-rows.state';

export const ToggleExpandButton = () => {
   const { expandAll, isAllExpanded, collapseAll, isAnyExpanded } = useExpanded();
   return isAnyExpanded ? (
      <StyledTooltip title={'Collapse all'}>
         <StyledToolbarButton ssrIcon={collapseIcon} iconOnly={true} small={true} onClick={collapseAll} disabled={!isAnyExpanded} />
      </StyledTooltip>
   ) : (
      <StyledTooltip title={'Expand all'}>
         <StyledToolbarButton ssrIcon={expandIcon} iconOnly={true} small={true} onClick={expandAll} disabled={isAllExpanded} />
      </StyledTooltip>
   );
};
